import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Chart} from 'chart.js';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSnackBar} from "@angular/material/snack-bar";

export interface TableFeatures {
  variable: string;
  stabili: number;
  miglioramento: number;
  peggioramento: number;
}

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.css']
})

export class ResultsComponent implements OnInit {

          // per inizializzazione
          getAuthState: Observable<any>;
          getDoctorState: Observable<any>;
          isAuthenticated: boolean;
          user = null;
          errorMessage = null;
          subscription1: Subscription;
          subscription2: Subscription;
          subscription3: Subscription;
          subscription5: Subscription;
          //

          //0 stabili, 1 miglioramento, 1 peggioramento
          numberCrohn: number[] = [0,0,0];
          numberUc: number[]=[0,0,0];
          numberUomo: number[]=[0,0,0];
          numberDonna: number[]=[0,0,0];
          numberMediaAge: string[]=['','',''];
          numberMediaAgeAtDiagnosis: string[]= ['','',''];
          numberPatDurMedia: string[]=['','',''];
          numberInterventiSi: number[]= [0,0,0];
          numberInterventiNo: number[]=[0,0,0];

          labels: string[] = ["Numero Crohn", "Numero UC", "Numero Uomo", "Numero Donna", "Eta media", "Eta alla diagnosi media", "Durata patologia media", "Interventi Si", "Interventi No"];
          displayedColumns: string[] = ['variable', 'stabili', 'miglioramento','peggioramento'];

          ELEMENT_DATA: TableFeatures[] = [
            {variable: this.labels[0] ,stabili: 0, miglioramento: 0, peggioramento: 0},
            {variable: this.labels[1] ,stabili: 0, miglioramento: 0, peggioramento: 0},
            {variable: this.labels[2] ,stabili: 0, miglioramento: 0, peggioramento: 0},
            {variable: this.labels[3] ,stabili: 0, miglioramento: 0, peggioramento: 0},
            {variable: this.labels[4] ,stabili: 0, miglioramento: 0, peggioramento: 0},
            {variable: this.labels[5] ,stabili: 0, miglioramento: 0, peggioramento: 0},
            {variable: this.labels[6] ,stabili: 0, miglioramento: 0, peggioramento: 0},
            {variable: this.labels[7] ,stabili: 0, miglioramento: 0, peggioramento: 0},
            {variable: this.labels[8] ,stabili: 0, miglioramento: 0, peggioramento: 0},


          ];

          dataSource = this.ELEMENT_DATA;

          
          

       

        
          // ******************************************************************************************************************
          
          // ******************************************************************************************************************
          // seguenti righe: inizializzazione dei pazienti 
          // ******************************************************************************************************************
          miglioramento: any[];
          peggioramento: any[];
          stabili: any[];

          // constructor
          constructor(private store: Store<AppState>,
                      private doctorService: DoctorService,
                      private snackBar: MatSnackBar) {
            this.getAuthState = this.store.select(selectAuthState);
            this.getDoctorState = this.store.select(selectDoctorState);
          }
          // ******************************************************************************************************************
          // metodo all'inizio
          ngOnInit(): void {
            this.subscription5 = this.getAuthState.subscribe((state) => {
              this.isAuthenticated = state.isAuthenticated;
              this.user = JSON.parse(localStorage.getItem('user'));
              this.errorMessage = state.errorMessage;
              this.doctorService.getStableUnstableFeatures().subscribe((pat) => {
                console.log(pat);
                this.miglioramento=pat[0].Miglioramento;
                this.peggioramento=pat[0].Peggioramento;
                this.stabili=pat[0].Stabili;
                this.dosomething();

              })
            });
          }



          dosomething() {
            //0 stabili
            //1 miglioramento
            //2 peggioramento
            let numberMediaAgeAtDiagnosis: number[] = [0,0,0];
            let numberMediaAge: number[] = [0,0,0];
            let numberPatDurMedia: number[] = [0,0,0];
            this.miglioramento.forEach(element => {
              if(element.bodyStat.pathology==="Colite ulcerosa")
              this.numberUc[1]++;
              else this.numberCrohn[1]++;
              if(element.bodyStat.sex==='1')
              this.numberDonna[1]++;
              else this.numberUomo[1]++;
              numberMediaAge[1]=numberMediaAge[1]+parseInt(element.bodyStat.age);
              numberPatDurMedia[1]=numberPatDurMedia[1]+parseInt(element.bodyStat.pathologyDuration);
              numberMediaAgeAtDiagnosis[1]=numberMediaAgeAtDiagnosis[1]+parseInt(element.bodyStat.ageOfDiagnosis);
              if(element.bodyStat.interventi==='1')
              this.numberInterventiSi[1]++;
              else this.numberInterventiNo[1]++;  
                         
            });
            
            this.numberMediaAgeAtDiagnosis[1]=(numberMediaAgeAtDiagnosis[1]/this.miglioramento.length).toFixed(2);
            this.numberMediaAge[1]=(numberMediaAge[1]/this.miglioramento.length).toFixed(2);
            this.numberPatDurMedia[1]=(numberPatDurMedia[1]/this.miglioramento.length).toFixed(2);

            this.peggioramento.forEach(element => {
              if(element.bodyStat.pathology==="Colite ulcerosa")
              this.numberUc[2]++;
              else this.numberCrohn[2]++;
              if(element.bodyStat.sex==='1')
              this.numberDonna[2]++;
              else this.numberUomo[2]++;
              numberMediaAge[2]=numberMediaAge[2]+parseInt(element.bodyStat.age);
              numberPatDurMedia[2]=numberPatDurMedia[2]+parseInt(element.bodyStat.pathologyDuration);
              numberMediaAgeAtDiagnosis[2]=numberMediaAgeAtDiagnosis[2]+parseInt(element.bodyStat.ageOfDiagnosis);
              if(element.bodyStat.interventi==='1')
              this.numberInterventiSi[2]++;
              else this.numberInterventiNo[2]++;   
                         
            });
            
            this.numberMediaAgeAtDiagnosis[2]=(numberMediaAgeAtDiagnosis[2]/this.peggioramento.length).toFixed(2);
            this.numberMediaAge[2]=(numberMediaAge[2]/this.peggioramento.length).toFixed(2);
            this.numberPatDurMedia[2]=(numberPatDurMedia[2]/this.peggioramento.length).toFixed(2);
            
            this.stabili.forEach(element => {
              if(element.bodyStat.pathology==="Colite ulcerosa")
              this.numberUc[0]++;
              else this.numberCrohn[0]++;
              if(element.bodyStat.sex==='1')
              this.numberDonna[0]++;
              else this.numberUomo[0]++;
              console.log(element.bodyStat.pathologyDuration);
              console.log(element.bodyStat.ageOfDiagnosis);
              numberMediaAge[0]=numberMediaAge[0]+parseInt(element.bodyStat.age);
              numberPatDurMedia[0]=numberPatDurMedia[0]+parseInt(element.bodyStat.pathologyDuration);
              numberMediaAgeAtDiagnosis[0]=numberMediaAgeAtDiagnosis[0]+parseInt(element.bodyStat.ageOfDiagnosis);
             if(element.bodyStat.interventi==='1')
              this.numberInterventiSi[0]++;
              else this.numberInterventiNo[0]++;       
            });

            this.numberMediaAgeAtDiagnosis[0]=(numberMediaAgeAtDiagnosis[0]/this.stabili.length).toFixed(2);
            this.numberMediaAge[0]=(numberMediaAge[0]/this.stabili.length).toFixed(2);
            this.numberPatDurMedia[0]=(numberPatDurMedia[0]/this.stabili.length).toFixed(2);

                        //fill tabella
                        this.ELEMENT_DATA[0].stabili = this.numberCrohn[0];
                        this.ELEMENT_DATA[0].miglioramento = this.numberCrohn[1];
                        this.ELEMENT_DATA[0].peggioramento = this.numberCrohn[2];
                        this.ELEMENT_DATA[1].stabili = this.numberUc[0];
                        this.ELEMENT_DATA[1].miglioramento = this.numberUc[1];
                        this.ELEMENT_DATA[1].peggioramento = this.numberUc[2];
                        this.ELEMENT_DATA[2].stabili = this.numberUomo[0];
                        this.ELEMENT_DATA[2].miglioramento = this.numberUomo[1];
                        this.ELEMENT_DATA[2].peggioramento = this.numberUomo[2];
                        this.ELEMENT_DATA[3].stabili = this.numberDonna[0];
                        this.ELEMENT_DATA[3].miglioramento = this.numberDonna[1];
                        this.ELEMENT_DATA[3].peggioramento = this.numberDonna[2];
                        this.ELEMENT_DATA[4].stabili = parseFloat(this.numberMediaAge[0]);
                        console.log(this.ELEMENT_DATA[4].stabili);
                        console.log(parseFloat(this.numberMediaAge[0]));
                        this.ELEMENT_DATA[4].miglioramento = parseFloat(this.numberMediaAge[1]);
                        this.ELEMENT_DATA[4].peggioramento = parseFloat(this.numberMediaAge[2]);
                        this.ELEMENT_DATA[5].stabili = parseFloat(this.numberMediaAgeAtDiagnosis[0]);
                        this.ELEMENT_DATA[5].miglioramento = parseFloat(this.numberMediaAgeAtDiagnosis[1]);
                        this.ELEMENT_DATA[5].peggioramento = parseFloat(this.numberMediaAgeAtDiagnosis[2]);
                        this.ELEMENT_DATA[6].stabili = parseFloat(this.numberPatDurMedia[0]);
                        this.ELEMENT_DATA[6].miglioramento = parseFloat(this.numberPatDurMedia[1]);
                        this.ELEMENT_DATA[6].peggioramento = parseFloat(this.numberPatDurMedia[2]);
                        this.ELEMENT_DATA[7].stabili = this.numberInterventiSi[0];
                        this.ELEMENT_DATA[7].miglioramento = this.numberInterventiSi[1];
                        this.ELEMENT_DATA[7].peggioramento = this.numberInterventiSi[2];
                        this.ELEMENT_DATA[8].stabili = this.numberInterventiNo[0];
                        this.ELEMENT_DATA[8].miglioramento = this.numberInterventiNo[1];
                        this.ELEMENT_DATA[8].peggioramento = this.numberInterventiNo[2];
            
            
          }
          ngOnDestroy(): void {
           
          }
        }